/**
 * 文件库枚举定义
 */

/** 文件夹类型 */
export enum FolderType {
  /** 普通目录 */
  NORMAL = 'normal',
  /** 系统目录 */
  SYSTEM = 'system',
}

/** 权限级别 */
export enum PermissionLevel {
  /** 无权限 */
  NONE = 'none',
  /** 查看 */
  VIEW = 'view',
  /** 编辑 */
  EDIT = 'edit',
  /** 管理 */
  MANAGE = 'manage',
}

/** 权限主体类型 */
export enum SubjectType {
  /** 角色 */
  ROLE = 'role',
  /** 用户 */
  USER = 'user',
}

/** 版本状态 */
export enum VersionStatus {
  /** 活跃 */
  ACTIVE = 'active',
  /** 已归档 */
  ARCHIVED = 'archived',
  /** 待删除 */
  PENDING_DELETE = 'pending_delete',
}

/** 访问日志操作类型 */
export enum AccessLogAction {
  /** 查看 */
  VIEW = 'view',
  /** 下载 */
  DOWNLOAD = 'download',
  /** 上传 */
  UPLOAD = 'upload',
  /** 更新 */
  UPDATE = 'update',
  /** 删除 */
  DELETE = 'delete',
  /** 移动 */
  MOVE = 'move',
  /** 复制 */
  COPY = 'copy',
  /** 权限变更 */
  PERMISSION_CHANGE = 'permission_change',
  /** 版本上传 */
  VERSION_UPLOAD = 'version_upload',
  /** 版本回退 */
  VERSION_ROLLBACK = 'version_rollback',
}

/** 文件目标类型（用于访问日志等） */
export enum FileTargetType {
  /** 文件夹 */
  FOLDER = 'folder',
  /** 文件 */
  FILE = 'file',
}
